import React, { useEffect } from "react";
import OpenModalButton from "../components/OpenModalButton";
import LoginForm from "../components/LoginForm";
import SignupForm from "../components/SignupForm";

const CustomAlert = ({ message, onClose, closeMenu, autoDismissMs = null }) => {
  useEffect(() => {
    if (!autoDismissMs || !onClose) return undefined;
    const timer = setTimeout(onClose, autoDismissMs);
    return () => clearTimeout(timer);
  }, [autoDismissMs, onClose, message]);

  const isToast = Boolean(autoDismissMs);

  return (
    <>
      {/* Blocking Overlay (skipped for auto-dismiss toasts) */}
      {!isToast && <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>}

      {/* Alert Box */}
      <div
        className="fixed top-32 left-1/2 transform -translate-x-1/2 bg-red-300 text-white px-4 py-3 rounded-lg shadow-lg z-50 sm:w-3/4 md:w-1/2 max-w-sm w-11/12"
      >
        <div className="flex items-center justify-between">
          <div className="text-sm sm:text-base break-words">
            {message ? (
              // Show the provaided message
              <span className="font-medium">{message}</span>
            ) : (
              // Default message with login and signup buttons
              <>
                Please{" "}
                <OpenModalButton
                  buttonText={
                    <span className="text-blue-700 hover:text-blue-500">
                      log in
                    </span>
                  }
                  onButtonClick={onClose} // Close alert when opening the modal
                  modalComponent={<LoginForm closeMenu={closeMenu} />}
                />{" "}
                or{" "}
                <OpenModalButton
                  buttonText={
                    <span className="text-blue-700 hover:text-blue-500">
                      sign up
                    </span>
                  }
                  onButtonClick={onClose} // Close alert when opening the modal
                  modalComponent={<SignupForm />}
                />{" "}
                to use this feature.
              </>
            )}
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="text-lg font-bold text-white focus:outline-none ml-4"
          >
            ×
          </button>
        </div>
      </div>
    </>
  );
};

export default CustomAlert;
